import React, { MouseEvent } from "react"

import HandImg from "@shared/assets/images/img_hand.png"
import { useSchedule } from "@shared/contexts"
import { redirectLoginUrl } from "@shared/modules"

import { URL, WOW_MONEY_UNIT_PRICE } from "live/constants"

const Anonymous = () => {
  const { schedule } = useSchedule()
  const scheduleId = schedule?.id

  return (
    <div className="coinCont coinLoginBefore">
      <img src={HandImg} alt="" />
      <div className="coinTxt">
        <strong>
          <span className="colorOrange">잠깐!</span> 1시간 마다
          <br />{" "}
          <span className="colorOrange">
            {WOW_MONEY_UNIT_PRICE.toLocaleString()}원
          </span>{" "}
          적립~
        </strong>
      </div>
      <a
        href={URL.WHAT_IS_WOW_MONEY}
        target="_blank"
        rel="noopener noreferrer"
        className="whatCoinLink"
      >
        와우머니란?
      </a>
      <br />
      <a
        href="#!"
        className="coinLoginLink"
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          if (!scheduleId) return

          redirectLoginUrl(scheduleId)
        }}
      >
        로그인
      </a>
    </div>
  )
}

export default Anonymous
